import { EmptyState, UserRoundPlusIcon } from '@buffer-mono/popcorn'

import styles from './FollowerThresholdEmptyState.module.css'

import type { JSX } from 'react'

/**
 * Empty state shown inside a channel-level time-series chart for a Facebook Page
 * below Meta's follower threshold, where reach/views are unavailable by design
 * rather than missing — the follower-specific variant of the generic "no data"
 * notice. @see CORE-6425
 */
export function FollowerThresholdEmptyState(): JSX.Element {
  return (
    <EmptyState size="small" className={styles.emptyState}>
      <EmptyState.Icon>
        <UserRoundPlusIcon stroke={1.5} />
      </EmptyState.Icon>
      <EmptyState.Description>
        Insights become available once your Facebook Page reaches 100 followers.
        Keep posting!
      </EmptyState.Description>
    </EmptyState>
  )
}
